import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { confirmModal } from '@/components/ui/modal'
import { isApiError } from '@/lib/api/errors'
import { useModuleLinks } from '../../catalogApi'
import { toastError } from '../../ui'

type Args = { moduleId: string; moduleName: string; projectId: string; projectName: string }

/** Onay + modülü projeden çıkarma; projede ona bağlı modül varsa nedenini gösterir. */
export function useUnlinkModule() {
  const { t } = useTranslation()
  const { unlink } = useModuleLinks()
  return async ({ moduleId, moduleName, projectId, projectName }: Args) => {
    const ok = await confirmModal({
      title: t('projects.modules.deleteTitle'),
      description: t('projects.modules.deleteBody', { name: moduleName, project: projectName }),
      confirmLabel: t('projects.modules.remove'),
      destructive: true,
    })
    if (!ok) return false
    try {
      await unlink.mutateAsync({ projectId, moduleId })
      toast.success(t('projects.modules.deleted'))
      return true
    } catch (e) {
      const names = isApiError(e) && e.code === 'MODULE_HAS_DEPENDENTS' ? (e.details as { modules?: string[] } | undefined)?.modules : undefined
      if (names) toast.error(t('errors.MODULE_HAS_DEPENDENTS'), { description: names.join(', ') })
      else toastError(e)
      return false
    }
  }
}
